import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCake = (props: SvgProps) => (
  <Svg fill="none" height={40} width={44} {...props}>
    <Path
      d="M11.997 0h4.008v4.008h-4.008zm8 0h4.007v4.008h-4.008zm7.998 0h4.008v4.008h-4.008zM16.001 6.003v10h4v-10H24v10h4v-10h3.999v10h8V36h3.999v4H.002v-4h4V16.002H12V6.003zM8 20.002v6h2.324l5.676 1.891 5.999-2 6 2 5.675-1.892h2.324v-5.999zM36 30.001h-1.676l-6.324 2.108-5.999-2-6 2L9.678 30H8.001v6H36z"
      fill="#F49090"
    />
  </Svg>
);
const Memo = memo(SvgCake);
export default Memo;
